import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar: React.FC = () => {
  const [isCollapsed, setIsCollapsed] = useState(true); // Start collapsed by default
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      {/* Toggle Button - Always visible */}
      <button 
        className={`sidebar-toggle ${isCollapsed ? 'collapsed' : ''}`}
        onClick={() => setIsCollapsed(!isCollapsed)}
        aria-label={isCollapsed ? 'Open sidebar' : 'Close sidebar'}
      >
        <i className={`fas ${isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'}`}></i>
      </button>

      {/* Sidebar */}
      <nav className={`side-nav ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="logo">
          <span className="logo-emoji">🩺</span>
          {!isCollapsed && <h1>SKILLSCOPE</h1>}
        </div>
        
        <div className="nav-items">
          <Link 
            to="/department" 
            className={`nav-item ${isActive('/department') ? 'active' : ''}`}
            title="Department Home"
          >
            <i className="fas fa-home"></i>
            {!isCollapsed && <span>Department Home</span>}
          </Link>
          <Link 
            to="/residents" 
            className={`nav-item ${isActive('/residents') ? 'active' : ''}`}
            title="Resident Stats"
          >
            <i className="fas fa-user"></i>
            {!isCollapsed && <span>Resident Stats</span>}
          </Link>
          <Link 
            to="/teaching" 
            className={`nav-item ${isActive('/teaching') ? 'active' : ''}`}
            title="Teaching Hub"
          >
            <i className="fas fa-book"></i>
            {!isCollapsed && <span>Teaching Hub</span>}
          </Link>
          <Link 
            to="/insights" 
            className={`nav-item ${isActive('/insights') ? 'active' : ''}`}
            title="AI Insights"
          >
            <i className="fas fa-lightbulb"></i>
            {!isCollapsed && <span>AI Insights</span>}
          </Link>
        </div>
      </nav>
    </>
  );
};

export default Sidebar;
